export default __webpack_public_path__ + "static/media/infra-13.6bc99613.webp";